import APP_ACTIONS from '../constants/app-actions';

const initialState = {
    availableZones: [],
    currentZone: undefined,
};

const zone = (state = initialState, action) => {
    if (action.type === APP_ACTIONS.SET_AVAILABLE_ZONES) {
        return {
            ...state,
            availableZones: action.payload,
        };
    }
    if (action.type === APP_ACTIONS.SET_CURRENT_ZONE) {
        return {
            ...state,
            currentZone: action.payload,
        };
    }
    return state;
};

export default zone;



/** WEBPACK FOOTER **
 ** ./src/reducers/zone.js
 **/